import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { useCurrentAccountId } from '@zapier/design-system-revenue/src/hooks';
import { currencyRulesetQuery as currencyRulesetQueryData } from './types/currencyRulesetQuery';

export const currencyRulesetQuery = gql`
  query currencyRulesetQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      currencyRuleset {
        currency
        method
        processor
        submethod
        submethodDisplay
      }
    }
  }
`;

export const useCurrencyRuleset = () => {
  const { accountId } = useCurrentAccountId();

  const { data, error, loading } = useQuery<currencyRulesetQueryData>(
    currencyRulesetQuery,
    {
      skip: !accountId,
      variables: { accountId },
    }
  );

  return {
    error: error ? 'There was an issue loading data.' : undefined,
    isLoading: loading,
    currencyRuleset: data?.account?.currencyRuleset ?? [],
  };
};
